import { config } from "../configs/config";
import { h } from "@/app/helpers";
import Axios from "axios";

export async function login(data, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/auth/login`,
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    data,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function dashboardCounts(params, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/metrics/token-purchased`,
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    params,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function dashboardTotals(params, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/metrics/deposits-total`,
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    params,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function getTransactions(params, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/metrics/transactions`,
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    params,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function getStores(params, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/metrics/stores`,
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    params,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function getUsers(params, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/metrics/users`,
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    params,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function deleteUser(id, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/user/${id}`,
    method: "delete",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function deleteTransaction(id, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/transactions/${id}`,
    method: "delete",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function cancelTransaction(id, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/transactions/cancel/${id}`,
    method: "delete",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function createUser(data, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/user/create`,
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    data,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function exportTransaction(data, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/transaction/export`,
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    data,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function addToken(data, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/user/${data.id}/payment-link`,
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    data,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function getPaymentLinks(id, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/user/${id}/payment-link`,
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function getUserProfile(id, params = {}, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/user/${id}`,
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    params,
  });
  return h.api.handleApiResponse(response, showMessage);
}

export async function updateUserProfile(id, data, showMessage = false) {
  const response = await Axios({
    url: `${config.apiUrl}/v1/admin/user/${id}`,
    method: "put",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
    },
    data,
  });
  return h.api.handleApiResponse(response, showMessage);
}
